import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useDispatch } from 'store/hooks';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { inscriptionUpdateApiCall } from 'routes/BudgetModule/shared/entities/inscription';
import { InscriptionQueryKey } from 'routes/BudgetModule/helpers/createBudgetQueryKeys';

export const useMutateMoveInscription = (cacheKey: InscriptionQueryKey) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: inscriptionUpdateApiCall,
        onSuccess: (response) => {
            dispatch.vision.notifyUser({
                message: response.content.message,
                snackType: 'success',
            });

            trackEventBudget(TRACKABLE_EVENTS.budget.general.moveInscription);
            // if we need to improve performance here by using setQueryData,
            // we need to filter out the moved inscription if its resources have changed.
            // As the cost is not that high, I chose to refetch the data for simplicity.
            queryClient.invalidateQueries({ queryKey: cacheKey });
        },
        meta: { useGlobalOnError: true },
    });
};
